<div *ngIf="(vm$ | async) as vm">
    <app-page-header [vm]="vm" title='{{reportTitle}}' [canGoBack]="vm.actionsAllowed" [canRefresh]="vm.actionsAllowed"
        [canExportExcel]="vm.actionsAllowed && vm.canExportExcel" (refreshClick)="refreshPage(vm)" [notify]="notifyObj"
        (exportExcelClick)="exportExcelClick(vm)"></app-page-header>

    <!-- filtering -->
    <mdb-card class="mb-3" cascade="true" narrower="true" style="height: 6rem"
        *ngIf="vm.showFilter && vm.filterVm && vmd.showTable">
        <mdb-card-body cascade="true" class="py-2">
            <div class="row" style="height: 4rem">
                <div class="col-md-3 mt-n3 mb-0">
                    <app-form-auto-complete [vm]="vm.filterVm.salesPersonCodeAutoCompleteVm"
                        (selected)="requestFormValidate(vm, vm)"></app-form-auto-complete>
                </div>
                <div class="col-md-2 mt-n3 mb-0">
                    <app-form-select [vm]="vm.filterVm.pickupMonthSelectVm"></app-form-select>
                </div>
                <div class="col-md-2 mt-n3 mb-0">
                    <app-form-select [vm]="vm.filterVm.yearToCompareVm"
                            [optionValue]="vm.filterVm.data.yearToCompare"
                            (selectChanged)="yearToCompareChanged($event, vm)"></app-form-select>
                </div>
                <div class="col-md-3 mt-n3 mb-0">
                    <app-form-select [vm]="vmd.selectActiveLineVm"
                            [optionValue]="vmd.data.activeLineIndex"
                            (selectChanged)="selectActiveLineChanged($event, vmd, vm)"></app-form-select>
                </div>
                <div class="col-md-2 mt-1 mb-0">
                    <div *ngIf="vm.reportVm && !vm.reportVm.workingText">
                        <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect (click)="doSearch(vm)"
                            mdbTooltip="Search">
                            <mdb-icon fas icon="search"></mdb-icon>
                        </a>
                    </div>
                    <div *ngIf="!vm.reportVm || vm.reportVm.workingText">
                        <span>{{vm.reportVm ? vm.reportVm.workingText : "Initializing..."}}</span>
                    </div>
                </div>
            </div>
        </mdb-card-body>
    </mdb-card>

    <!-- content -->
    <div *ngIf="vm.reportVm as rvm">

        <!-- working -->
        <div class="row" *ngIf="rvm.workingText">
            <div class="col-md-12">
                <div class="text-center">
                    <div>{{rvm.workingText}}</div>
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </div>
            </div>
        </div>

        <!-- error -->
        <div class="row" *ngIf="rvm.errorText">
            <div class="col-md-12">
                <div class="text-center text-danger">
                    <div>{{rvm.errorText}}</div>
                </div>
            </div>
        </div>

        <!-- tabs -->
        <div class="mt-3" *ngIf="!rvm.workingText && !rvm.errorText && vmd.showTable">
            <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'" *ngIf="rvm.tabVms"
                (getActiveTab)="onGetActiveTab(vm, $event)">
                <mdb-tab *ngFor="let tvm of rvm.tabVms" [heading]="tvm.title">
                    <div *ngIf="tvm.active">
                        <app-data-table [vm]="tvm.tableVm" [data]="vm" [searchableColumns]="tvm.searchableColumns"
                            [showTotalsOnTop]="true" (showDetails)="showDetails($event)" [baseCode]="tvm.detailsPageCommandCode" [baseAction]="tvm.detailsPageCommandAction"
                            [keyIndex]="0" [activeLineIndex]="activeLineIndex"></app-data-table>
                    </div>
                </mdb-tab>
            </mdb-tabset>
        </div>

        <div *ngIf="vmd.detailsFormVm">
            <div class="row mt-3 mb-n3" *ngIf="!vmd.detailsFormVm.workingText">
                <div class="col-md-11"></div>
                <div class="col-md-1 text-right">
                    <a class="text-danger" (click)="showDetailsEnd()"><i class="fas fa-times fa-lg"></i></a>
                </div>
            </div>
            <!-- working -->
            <div class="row" *ngIf="vmd.detailsFormVm.workingText">
                <div class="col-md-12">
                    <div class="text-center">
                        <div>{{vmd.detailsFormVm.workingText}}</div>
                        <mdb-spinner spinnerColor="blue"></mdb-spinner>
                    </div>
                </div>
            </div>

            <!-- error -->
            <div class="row" *ngIf="vmd.detailsFormVm.errorText">
                <div class="col-md-12">
                    <div class="text-center text-danger">
                        <div>{{vmd.detailsFormVm.errorText}}</div>
                    </div>
                </div>
            </div>
            <div class="mt-3" *ngIf="!vmd.detailsFormVm.workingText && !vmd.detailsFormVm.errorText">
                <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'"
                    *ngIf="vmd.detailsFormVm.tabDetailsVms" (getActiveTab)="onGetDetailsActiveTab($event)">
                    <mdb-tab *ngFor="let tvm of vmd.detailsFormVm.tabDetailsVms" [heading]="tvm.title">
                        <div *ngIf="tvm.active">
                            <app-data-table [vm]="tvm.tableVm" [searchableColumns]="tvm.searchableColumns" [showTotalsOnTop]="true"
                                [keyIndex]="0" [activeLineIndex]="activeLineIndex"></app-data-table>
                        </div>
                    </mdb-tab>
                </mdb-tabset>
            </div>
        </div>
    </div>

</div>